import { ACCOUNTS_DASHBOARD_URL } from 'redux/actions/constants';

const TEACHER_TYPES = ['OTHER', 'DEMO-OTHER'];

export const isLoggedInUser = (user) => user?.id > 0;

export const isTeacherUser = (user) =>
  isLoggedInUser(user) && TEACHER_TYPES.includes(user.userType);

// The accounts portal accepts the session token via ?op= (same as sign-in).
export const teacherPanelUrlFor = (token) =>
  token ? `${ACCOUNTS_DASHBOARD_URL}?op=${token}` : ACCOUNTS_DASHBOARD_URL;
